import callCmAPI from 'services/helpers/call-cm-api'
import { Zone, WebApi2Response } from 'types'

/******************
 * Fetch from API *
 ******************/

export type UpdateZoneArgs = {
  // The current zone name identifies the zone to update.
  name: string
  update_data: {
    // A new name (only when renaming) and/or the new resolved country set.
    name?: string
    countries?: string[]
  }
}

// Updates an existing custom global zone via the CMAPI write proxy
// (PUT /global-data/update-zone -> RisikaAPI /zone/update).
export const updateZone = (
  body: UpdateZoneArgs,
): Promise<WebApi2Response<Zone>> =>
  callCmAPI('/global-data/update-zone', {
    method: 'put',
    data: body,
  })
    .then((res) => {
      return { success: true as const, data: res.data as Zone }
    })
    .catch((err) => {
      return {
        success: false as const,
        data: null,
        error: err,
      }
    })
